import { Box, Stack, styled, Typography } from "@mui/material";
import React from "react";
import { conradEnergyFreshGreenColour } from "../../../shared/theme/themeBrand";
import { DataGrid, GridColDef} from "@mui/x-data-grid";
import { common } from "@mui/material/colors";
import { IPerfmonFileSubmission } from "../../../shared/types/dispatch/IFailedPerformanceMetrics";
import { FormatDateToString } from "../../../shared/helpers/dateTimeHelper";
import { FormatSettlementPeriods } from "./helpers/FormatSettlementPeriods";

const StyledDataGrid = styled(DataGrid)(({ theme }) => ({
    border: "none",
    "& .MuiDataGrid-columnSeparator": {
        display: "none",
    },
    "& .data-grid-text-success": {
        color: theme.palette.success.main,
    },
    "& .data-grid-text-error": {
        color: theme.palette.error.main,
    },
    ".MuiDataGrid-columnHeaders": {
        background: common.black,

        "> div:first-of-type": {
            background: common.black,
            "> .MuiDataGrid-columnHeader": {
                height: "auto",
            },
            "& .MuiDataGrid-columnHeaderTitle": {
                whiteSpace: "normal !important",
                wordWrap: "normal !important",
                textAlign: "center",
            },
            "& .MuiDataGrid-sortIcon": {
                width: 0,
                height: 0,
                borderLeft: "6px solid transparent",
                borderRight: "6px solid transparent",
                borderBottom: "10px solid currentColor",
                marginLeft: 4,
                opacity: 1,
                visibility: "visible",
            },
        },
    },
    "& .MuiDataGrid-columnHeaderTitle": {
        fontSize: "17px",
        fontWeight: "bold",
    },
    "& .invisible-col": {
        color: "transparent",
        pointerEvents: "none",
        userSelect: "none",
        textIndent: "-9999px",
        overflow: "hidden",
    },
    "& .invisible-col-header": {
        opacity: 0,
        userSelect: "none",
        textIndent: "-9999px", 
        overflow: "hidden",
    },
}));

export const SuccessfullySubmittedPerformanceTable: React.FC<ISuccessfullySubmittedPerformanceTableProps> = ({ data, onClickDownloadFile }) => {
    const columns: GridColDef<IPerfmonFileSubmission>[] = [
        {
            field: 'site',
            headerName: 'Site',
            disableColumnMenu: true,
            width: 150,
            resizable: false,
            align: "left",
            headerAlign: "left",
            valueGetter: (params) => `${params.row.site}`,
        },
        {
            field: 'performanceMonitoringFileBegins',
            headerName: "File Begins",
            disableColumnMenu: true,
            width: 150,
            align: "left",
            headerAlign: "left",
            valueFormatter: (params) => FormatDateToString(params.value, "DD.MM.YYYY HH:mm")
        },
        {
            field: 'settlementPeriods',
            headerName: "Settlement Periods",
            disableColumnMenu: true,
            width: 250,
            align: "center",
            headerAlign: "center",
            valueFormatter: (params) => FormatSettlementPeriods(params.value)
        },
        {
            field: 'lastSubmitted',
            headerName: "Last Submitted",
            disableColumnMenu: true,
            width: 200,
            align: "center",
            headerAlign: "center",
            valueFormatter: (params) => params.value ? FormatDateToString(params.value, "DD.MM.YYYY HH:mm") : "-"
        },
        {
            field: 'lastErrorCode',
            headerName: "",
            disableColumnMenu: true,
            width: 300,
            align: "center",
            headerAlign: "center",
            headerClassName: 'invisible-col-header',
            cellClassName: 'invisible-col',
        },
        {
            field: '',
            headerName: "",
            disableColumnMenu: true,
            flex: 1,
            minWidth: 200,
            align: "left",
            headerAlign: "left",
            headerClassName: 'invisible-col-header',
            cellClassName: 'invisible-col',
        },
    ];
    return (
        <Box height="100%">
            <Stack direction="column" >
                <Typography
                    sx={{ fontWeight: "bold", lineHeight: 2, color: conradEnergyFreshGreenColour.main }} height="100%" variant="h5" noWrap>
                    Successfully Submitted
                </Typography>

                <Box sx={{ width: '100%', height: 300, overflow: "auto" }}>
                    <StyledDataGrid
                        getRowId={(row) => `${row.id}`}
                        autosizeOnMount
                        autosizeOptions={{
                            includeHeaders: true,
                            expand: true,
                            columns: ["siteID"]
                        }}
                        rows={data}
                        // @ts-expect-error
                        columns={columns}
                        disableRowSelectionOnClick
                        autoHeight={false}
                        initialState={{
                            sorting: {
                                sortModel: [{ field: 'performanceMonitoringFileBegins', sort: 'desc' }],
                            },
                        }}
                    >
                    </StyledDataGrid>
                </Box>
            </Stack>
        </Box>
    );
}


export interface ISuccessfullySubmittedPerformanceTableProps {
    data: IPerfmonFileSubmission[];
    onClickDownloadFile: (perfmonFile: IPerfmonFileSubmission) => void;
}
